import { useEffect, useState } from "react";
import { useI18n } from "@/lib/i18n";

/** Returns time (HH:MM:SS) remaining until next 15:00 CET dispatch cutoff. */
function useDispatchCountdown() {
  const [t, setT] = useState({ h: 0, m: 0, s: 0, past: false });
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const cutoff = new Date();
      cutoff.setHours(15, 0, 0, 0);
      let diff = cutoff - now;
      let past = false;
      if (diff <= 0) {
        // Show time until tomorrow's cutoff
        cutoff.setDate(cutoff.getDate() + 1);
        diff = cutoff - now;
        past = true;
      }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setT({ h, m, s, past });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return t;
}

export default function DispatchCountdown({ variant = "default" }) {
  const t = useDispatchCountdown();
  const { lang } = useI18n();
  const nl = lang === "nl";
  const de = lang === "de";
  const pad = (n) => String(n).padStart(2, "0");
  const beforeLabel = nl
    ? "Verzonden vandaag als je bestelt binnen"
    : de
    ? "Heute versandt wenn Sie bestellen innerhalb"
    : "Ships today if you order within";
  const afterLabel = nl
    ? "Volgende zending in"
    : de
    ? "Nächste Sendung in"
    : "Next dispatch in";
  if (variant === "compact") {
    return (
      <span data-testid="dispatch-countdown" className="font-mono-label text-[10px] tracking-[0.15em]">
        {t.past ? "NEXT " : ""}
        <span className="text-[#00529B] font-semibold">{pad(t.h)}:{pad(t.m)}:{pad(t.s)}</span>
      </span>
    );
  }
  return (
    <div
      data-testid="dispatch-countdown-box"
      className="inline-flex items-center gap-3 border border-neutral-300 bg-white px-4 py-3"
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-70" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
      </span>
      <span className="font-mono-label text-[10px] text-neutral-700">
        {t.past ? afterLabel : beforeLabel}
      </span>
      <span className="font-mono-label text-[11px] tracking-[0.2em] text-black font-semibold">
        {pad(t.h)}<span className="text-neutral-400">:</span>{pad(t.m)}<span className="text-neutral-400">:</span>{pad(t.s)}
      </span>
    </div>
  );
}
